import React from 'react';
import { motion } from 'framer-motion';
import { 
  Users, 
  Package, 
  CurrencyDollar,
  ShoppingCart
} from '@phosphor-icons/react';

const OverviewTab = ({ analytics }) => {
  const statCards = [
    { label: 'Total Users', value: analytics?.total_users || 0, icon: Users, color: 'text-blue-500' },
    { label: 'Premium Users', value: analytics?.premium_users || 0, icon: Users, color: 'text-white' },
    { label: 'Elite Users', value: analytics?.elite_users || 0, icon: Users, color: 'text-[#D4AF37]' },
    { label: 'Total Revenue', value: `$${(analytics?.total_revenue || 0).toFixed(2)}`, icon: CurrencyDollar, color: 'text-green-500' },
    { label: 'Total Orders', value: analytics?.total_orders || 0, icon: ShoppingCart, color: 'text-purple-500' },
    { label: 'Products', value: analytics?.total_products || 0, icon: Package, color: 'text-orange-500' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {statCards.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-[#121212] border border-white/5 p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <span className="text-xs font-mono uppercase tracking-wider text-zinc-500">{stat.label}</span>
            <stat.icon className={`w-5 h-5 ${stat.color}`} weight="duotone" />
          </div>
          <p className={`text-3xl font-outfit font-medium ${stat.color}`}>{stat.value}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default OverviewTab;
